import '@loyal_modules/carousel/css/owl.carousel.css'
import '@loyal_modules/carousel/css/owl.theme.default.min.css'
import { Icon } from 'loyal-react'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import OwlCarousel from 'react-owl-carousel2'
import { Link } from 'react-router-dom'
import { Item } from './Item'

class Tracking extends Component {
  constructor (props) {
    super(props)
    this.state = {
      options: {
        margin: 10,
        autoplay: false,
        dots: false,
        nav: false,
        rewind: false,
        loop: false,
        callbacks: true,
        responsive: {
          0: {
            items: 1,
            stagePadding: 10,
            loop: false,
            rewind: false
          }
        },
        navClass: [
          'pos-absolute showcase-nav showcase-prev bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon',
          'pos-absolute showcase-nav showcase-next bg-brand-1 d-none d-md-block border-color-brand-1 btn-icon'
        ],
        navText: [
          `<i class='icon icon_left icon-sm color-ui-white'></i>`,
          `<i class='icon icon_right icon-sm color-ui-white'></i>`
        ]
      },
      pageIndex: 1,
      pageSize: 1
    }
    this.loadProductsTracking = this.loadProductsTracking.bind(this)
    this.next = this.next.bind(this)
    this.prev = this.prev.bind(this)
    this.loadNextCard = this.loadNextCard.bind(this)
  }

  componentDidMount () {
    this.loadProductsTracking()
  }

  next () {
    this.refs.orders.next()
    setTimeout(this.loadNextCard, 300)
  }

  prev () {
    this.refs.orders.prev()
  }

  loadNextCard () {
    let nextPosition = this.refs.orders.currentPosition
    let lastPosition = this.state.pageIndex * this.state.pageSize
    if (
      !this.props.loading &&
      nextPosition === lastPosition &&
      this.props.hasMoreItems
    ) {
      this.loadNextPageProductsTracking()
    }
  }

  loadProductsTracking () {
    this.props.loadProductsTracking(this.state.pageIndex, this.state.pageSize)
  }

  loadNextPageProductsTracking () {
    this.setState(
      { pageIndex: this.state.pageIndex + 1 },
      this.loadProductsTracking
    )
  }

  render () {
    let items = null
    if (this.props.orderItems && this.props.orderItems.length > 0) {
      items = this.props.orderItems.map((orderItem, index) => {
        let visible =
          this.props.tracking &&
          this.props.tracking[orderItem.id] &&
          !this.props.tracking[orderItem.id].loading
        return (
          <Item
            {...this.props}
            loading={false}
            order={orderItem}
            index={index}
            style={{ visibility: visible ? 'visible' : 'hidden' }}
          />
        )
      })
    }
    return (
      <div
        className='tracking zindex-high col-md-auto col-auto d-none d-lg-block'
        aria-haspopup={this.props.totalRows && this.props.totalRows > 0}
      >
        <div className='row align-items-center h-100 justify-content-end justify-content-lg-center'>

          <Link className='d-block' to='/my-orders' tabIndex={0} aria-label='Meus pedidos'>
            <div className='col-auto pos-relative'>
              <strong className='tracking-count color-success txt-center txt-font-body pos-absolute'>
                {this.props.totalRows > 0 ? this.props.totalRows : ''}
              </strong>
              <div
                className={`traking-status border-ui-3 radius-circle p-1 ${
                  this.props.totalRows > 0 ? '' : 'percent-0'
                }`}
              >
                <Icon
                  iconName='icon_truck'
                  className='icon_only color-brand-5 cursor'
                />
              </div>
            </div>
          </Link>

        </div>
        {items && items.length > 0 && (
          <div className='resume-tracking bg-ui-5 radius pb-0 border-ui-3'>
            <div className='resume-header bg-white row  align-items-center h-100 mx-0 border-bottom border-color-ui-3 mx-0 px-2 py-2'>
              <div className='col mr-auto px-0'>
                <p className='h3 txt-font-title txt-title color-title'>
                  Pedidos
                </p>
              </div>
              <div className='col-auto'>
                <div className='row align-items-center h-100'>
                  <div className='col-12'>
                    <i
                      className='icon icon_left icon-sm color-ui-3 cursor'
                      onClick={this.prev}
                    />
                  </div>
                </div>
              </div>
              <div className='col-auto'>
                <div className='row align-items-center h-100'>
                  <div className='col-12'>
                    <i
                      className='icon icon_right icon-sm color-ui-3 cursor'
                      onClick={this.next}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='resume-body row mx-0'>
              <div className='panel-accordion active border-color-ui-3  px-1 py-1'>
                <div className='tracking-empty d-none  orders-item row mx-0 pt-1  pb-3 px-1'>
                  <div className='mr-auto ml-auto bg-ui-4 radius-circle px-3 py-3'>
                    <i className='icon icon_truck txt-headline color-brand-1' aria-hidden='true' />
                  </div>
                  <div className='col-12 mr-auto ml-auto  clearfix' />
                  <div className='col-12 px-0 mr-auto ml-auto  mt-2'>
                    <h3 className='txt-center txt-body'>
                      <strong>Você não possui pedidos em andamento</strong>
                    </h3>
                    <p className='txt-center txt-body-sm'>
                      Aproveite nossas ofertas agora mesmo.
                    </p>
                  </div>
                  <div className='col-12 clearfix' />
                  <div className='col-8 mr-auto ml-auto  mt-2'>
                    <button className='btn btn-sm btn-featured'>
                      Ver ofertas
                    </button>
                  </div>
                </div>
                <div className='tracking-list orders-item row mx-0 pt-1 px-0'>
                  <OwlCarousel
                    ref='orders'
                    className='bx-slider w-100 mx-0 owl-carousel owl-theme'
                    options={this.state.options}
                  >
                    {items}
                    {this.props.hasMoreItems && <Item loading />}
                  </OwlCarousel>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

Tracking.propTypes = {
  orders: PropTypes.array,
  orderstracking: PropTypes.array,
  getOrderDetails: PropTypes.func,
  loadProductsTracking: PropTypes.func,
  insertNetshoesLastEvent: PropTypes.func,
  orderItems: PropTypes.array,
  totalRows: PropTypes.number,
  loading: PropTypes.bool,
  hasMoreItems: PropTypes.bool,
  tracking: PropTypes.object
}

export default Tracking



// WEBPACK FOOTER //
// ./src/App/Header/Tracking/Tracking.js